import { render, staticRenderFns } from "./bonus-list-detail.vue?vue&type=template&id=13842dd4&"
import script from "./bonus-list-detail.vue?vue&type=script&lang=js&"
export * from "./bonus-list-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports